import { CommonComponentsModule } from 'src/app/components/common-components.module';
//import { TBPlayerCardComponent } from './../turbo-ballots-runner/tb-player-card/tb-player-card.component';
import { TbRankingVotesComponent } from './../tb-ranking-votes/tb-ranking-votes.component';
import { TBrankingComponent } from './tb-ranking.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';


@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    CommonComponentsModule
  ],
  declarations: [
   TBrankingComponent,
   TbRankingVotesComponent
   //TBPlayerCardComponent
  ],
  exports: [
   TBrankingComponent,
   TbRankingVotesComponent
   //TBPlayerCardComponent
  ]
})
export class TBrankingModule { }